import { AxiosRequestConfig } from 'axios';

import { useApiData } from '../../hooks';
import { useDashboardContext } from './contexts';

export const useGraphApiData = (url: string, config?: AxiosRequestConfig) => {
  const { activeFacilitySnapShot } = useDashboardContext();
  return useApiData(url, {
    ...config,
    params: { ...config?.params, client_id: activeFacilitySnapShot.clientId },
  });
};
export default useGraphApiData;
